<template>
  <div>
    <div v-show="showAddAndEdit" class="active_sessions">
      <div class="divider-line"></div>
      <!-- <div class="acctive-sessions-header" style="display:inline">可选场次：</div> -->
      <div>
        <draggable
          v-model="dynamicTags"
          animation="1000"
          filter=".unmover"
          @end="dragFinish"
        >
          <!--             style="display: inline-block; padding: 0 5px" -->
          <div :key="index" v-for="(tag, index) in dynamicTags">
            <!-- tag -->
            <div
              v-if="showTagIndex !== index"
              class="drag-edit-tag"
              closable
              :disable-transitions="false"
            >
              {{ index + 1 }}组：{{ tag.value }}

              <i
                @click="editTag(index)"
                class="drag-icon-edit el-icon-edit-outline"
              ></i>
            </div>
            <!-- tag输入框 -->
            <el-input
              style="width: auto"
              v-else
              size="mini"
              v-model="tag.value"
              class="input-new-tag"
              @keyup.enter.native="handleInputTag(tag)"
              @blur="handleInputTag(tag)"
            ></el-input>
          </div>
          <!-- 添加分组 -->
          <el-input
            size="mini"
            class="input-new-tag unmover"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          ></el-input>

          <el-button
            size="mini"
            v-else
            class="button-new-tag unmover"
            @click="showInput"
            >+ 添加分组</el-button
          >
          <span
            v-if="haveTags"
            @click="cancleAddTag"
            class="show-cancle-add"
            style="float: right; cursor: pointer; color: lightgray"
            >取消添加</span
          >
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
// vue-draggable 拖拽组件 的可拖拽列表
// 中文文档：https://juejin.cn/post/6844904150350692366
// 官方：https://www.npmjs.com/package/vuedraggable
// npm i -S vuedraggable
import draggable from "vuedraggable";
import { createLogger } from "vuex";
export default {
  name: "drag-list",
  components: {
    draggable,
  },
  data() {
    return {
      // 显示标签
      showTagIndex: -1,
      // 显示
      showAddAndEdit: this.showAddAndEditTag,
      haveTags: false, // 取消添加
      inputVisible: false,
      inputValue: "", // 输入内容

      // 数据
      dynamicTags: [],
      //   [
      //     {
      //       id: 4,
      //       value: "了解冲浪及浪板",
      //     },
      //     {
      //       id: 5,
      //       value: "认识冲浪板与冲浪基础",
      //     },
      //     {
      //       id: 2,
      //       value: "入门冲浪",
      //     },
      //     {
      //       id: 3,
      //       value: "进阶技巧",
      //     },
      //   ],
    };
  },
  props: {
    attribuite: Number,
    dynamicTagsProp: Array, // 绑定数据
    // 显示编辑标签
    showAddAndEditTag: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    dynamicTagsProp(newValue) {
      this.dynamicTags = newValue;
    },
  },
  methods: {
    //   拖拽
    // startDrag(e) {
    //   console.log("开始拖拽");
    //   console.log(e);
    // },
    dragFinish(e) {
      console.log("完成拖拽");
      console.log(e);
      console.log(this.dynamicTags);
      //   console.log(e.newIndex);
      //   console.log(value);
    },
    editTag(value) {
      console.log("编辑:" + value);
      this.showTagIndex = value;
    },
    //
    cancleAddTag() {
      //   console.log("取消");
      return;
      if (this.dynamicTags.length == 0) {
        this.haveTags = false;
        this.showAddAndEdit = false;
      } else {
        this.haveTags = false;
      }
    },
    showInput() {
      console.log("显示添加的输入框");
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputTag(value) {
      //   console.log("保存新的tag："+ tag.value);
      this.showTagIndex = "value";
      let item = {
        chapter_id: value.id,
        chapter: value.value,
      };
      this.$http.post("/renew_course_chapter", item).then((res) => {
        console.log(res);
      });
    },
    handleInputConfirm() {
      // 遍历以下，看看有没有一样的，如果有一样的得阻止
      console.log("监听隐藏输入框：" + this.inputValue);
      let inputValue = {
        value: this.inputValue,
      };
      if (inputValue) {
        this.dynamicTags.push(inputValue);
        let round = {
          // 修改输入内容
          sku_id: this.attribuite,
          round: this.dynamicTags,
        };
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
  },
};
</script>

<style>
/* .el-tag {
  display: block;
  width: 50%;
} */
.drag-edit-tag {
  background-color: #ffeee9;
  border-color: #ffddd3;
  display: inline-block;
  height: 32px;
  padding: 0 10px;
  line-height: 30px;
  font-size: 12px;
  color: #ff5421;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  box-sizing: border-box;
  white-space: nowrap;
  cursor: pointer;
}
.drag-edit-tag .drag-icon-edit {
  border-radius: 50%;
  text-align: center;
  position: relative;
  cursor: pointer;
  font-size: 12px;
  height: 16px;
  width: 16px;
  line-height: 16px;
  vertical-align: middle;
  top: -1px;
  right: -5px;
}
.drag-edit-tag + .drag-edit-tag {
  margin-left: 10px;
}

.drag-edit-tag .drag-icon-edit {
  color: #ff5421;
}

.active_sessions_none {
  display: none;
  margin-bottom: 10px;
  padding: 0px 10px;
  /* background-color: tomato; */
  border-radius: 3px;
}
.active_sessions {
  /* margin-bottom: 10px; */
  padding: 0px 10px;
  /* background-color: tomato; */
  border-radius: 3px;
}
.active_sessions:hover .show-cancle-add {
  display: inline;
}
.show-cancle-add {
  display: none;
}
.acctive-sessions-header {
  font-size: large;
  color: white;
}

.button-new-tag {
  /* margin-left: 10px; */
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.divider-line {
  height: 10px;
  /* margin-top: 20px; */
  border-top-style: solid;
  /* border-color: lightgray; */
  border-color: #fff;
}
</style>